/**
 * @description
 * Objeto AvisTipus
 */

import { AvisCategoria } from "./aviscategoria.model";

export class AvisTipus {
    public id:number = null;
    public code:string = "";
    public descript:string = "";
    public avisCategoria: AvisCategoria = new AvisCategoria();
    public urlinfo: string = "";

    constructor() {}
}